export function PlaceholderPage({ title, description }: { title: string; description?: string }) {
  return (
    <section className="page-card">
      <p className="eyebrow">Module</p>
      <h2>{title}</h2>
      <p className="muted">{description ?? 'This module will be connected to the Inventory ERP API in its implementation phase.'}</p>
    </section>
  );
}
